import { Component, computed, inject, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { CosmeticOptions, Displayable, Influence } from '../../models/filter-models';
import { DisplayType } from "../../models/enums";
import { Rarity } from "../../models/enums";
import { CosmeticsGeneratorService } from '../../services/cosmetics-generator.service';
import { TooltipWrapperComponent } from '../tooltip-wrapper/tooltip-wrapper.component';
import { MinimapIconComponent } from '../icons/minimap-icon/minimap-icon.component';
import { HighlightBeamIconComponent } from '../icons/highlight-beam-icon/highlight-beam-icon.component';
import { LabelViewerComponent } from '../label-viewer/label-viewer.component';
import { StylePickerDialogComponent } from '../style-picker/style-picker-dialog/style-picker-dialog.component';
import { tierStyleMap } from '../helper';
import { SettingsService } from '../../services/settings.service';
import { labelPreviewBgImageStyle } from '../label-preview-backgrounds';

@Component({
  selector: 'app-tier-style',
  imports: [TooltipWrapperComponent, MinimapIconComponent, HighlightBeamIconComponent, LabelViewerComponent, StylePickerDialogComponent],
  templateUrl: './tier-style.component.html',
  styleUrl: './tier-style.component.scss'
})
export class TierStyleComponent implements OnInit, OnChanges {
  private readonly settings = inject(SettingsService);

  labelBackgroundImage = computed(() => labelPreviewBgImageStyle(this.settings.labelPreviewBg()));

  @Input({ required: true }) displayable!: Displayable;
  @Input({ required: true }) allowedDisplayTypes!: DisplayType[];
  @Input() allowDisactivate = true;
  @Input() allowHide = true;
  @Input() forceHidden?: boolean;

  @Input() editable = true;

  @Input() exampleName?: string;

  @Input() rarity?: Rarity;
  @Input() isCurrency?: boolean;
  @Input() isWaystone?: boolean;
  @Input() isDivinationCard?: boolean;
  @Input() influence?: Influence;
  @Input() memoryStrands?: boolean;

  @Input() label?: string;
  @Input() isTitle = false;
  @Input() isHeader = false;

  @Input() styleDialogTitle?: string;

  @Output() styleUpdated = new EventEmitter<void>();

  cosmeticOptions: CosmeticOptions = new CosmeticOptions();
  hidden = false;

  tierStyle = '';

  dialogOpen = false;

  constructor(private cosmeticsGeneratorService: CosmeticsGeneratorService) {}

  ngOnInit(): void {
    this.updateTierStyleAndTitle();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['displayable']) {
      this.updateTierStyleAndTitle();
    }
  }

  updateTierStyleAndTitle(): void {
    const result = this.cosmeticsGeneratorService.getCosmeticOptionsFromDisplayOptions(this.displayable.displayOptions, this.exampleName, this.styleDialogTitle);
    Object.assign(this.cosmeticOptions, result.cosmeticOptions);
    this.hidden = result.hidden;

    const highlightColor = (this.cosmeticOptions?.highlight && this.cosmeticOptions?.highlightColor) || null;
    this.tierStyle = this.hidden
      ? 'tier-hidden'
      : !this.displayable.displayOptions.active
        ? 'tier-shown'
        : (highlightColor && tierStyleMap.has(highlightColor))
          ? tierStyleMap.get(highlightColor)!
          : 'tier-shown';
  }

  openStylePickerDialog() {
    if (this.editable) {
      this.dialogOpen = true;
    }
  }

  closeStylePickerDialog() {
    this.dialogOpen = false;
  }
}
